import React from 'react'
import styled from 'styled-components'
import bgAsset from '../../assets/background-asset.svg'

const PrimaryRootStyled = styled.div`
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  height: 100%;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${bgAsset});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.6;
    animation: glow2 5s infinite alternate;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at top, rgba(0, 0, 0, 0.76) 10%, rgba(0, 0, 0, 1) 100%);
    pointer-events: none;
  }

  @keyframes glow2 {
    0% {
      opacity: 0.8;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.8;
    }
  }
`
const SecondaryRootStyled = styled.div`
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  height: 100%;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: radial-gradient(circle at top, rgba(74, 251, 57, 0.1) 0%, rgba(18, 18, 18, 0.2) 90%);
    animation: glow 5s infinite alternate;
  }

  @keyframes glow {
    0% {
      background: radial-gradient(circle at top, rgba(74, 251, 57, 0.3) 0%, rgba(18, 18, 18, 0.5) 90%);
      opacity: 0.1;
    }
    50% {
      background: radial-gradient(circle at top, rgba(74, 251, 57, 0.3) 0%, rgba(18, 18, 18, 0.5) 90%);
      opacity: 0.8;
    }
    100% {
      background: radial-gradient(circle at top, rgba(74, 251, 57, 0.3) 0%, rgba(18, 18, 18, 0.5) 90%);
      opacity: 0.1;
    }
  }
`

interface RootWrapperI {
  children: React.ReactNode
}

/* Style usage only */
const RootWrapper: React.FC<RootWrapperI> = ({ children }) => {
  return (
    <PrimaryRootStyled>
      <SecondaryRootStyled>{children}</SecondaryRootStyled>
    </PrimaryRootStyled>
  )
}
export default RootWrapper
